import configureCommands from './configure-commands';
import { createInvokerWithCache } from '@drapejs/core';
import consola from 'consola';

if (process.env.NODE_ENV == 'development') {
  consola.level = 5;
}

configureCommands(createInvokerWithCache());
